export default {

    _canElementScrollVertically(element) {
        const overflowY = getComputedStyle(element).getPropertyValue("overflow-y");
        return overflowY !== "hidden" && overflowY !== "visible";
    },

    _isElementScrollingVertically(element) {
        return element.scrollHeight > element.clientHeight && this._canElementScrollVertically(element);
    },

    /**
     * Find the first parent element that has scrolling.
     * @private
     */
    _findScroll: function(element, limit) {
        element = element.parentElement;
        while (element !== null && element !== limit) {
            if(this._isElementScrollingVertically(element)){
                return element;
            }
            element = element.parentElement;
        }
        return null;
    },

    /**
     * Determine if the given element is visible inside its scrolling container.
     * @private
     */
    _visibleInParentScroll: function(element, limit) {
        var scroll = this._findScroll(element, limit);
        if (!scroll) {
            return true;
        }
        return this._visibleInContainer(element, scroll);
    },

    /**
     * Determine if an element is visible in its parent scroll container.
     * @private
     */
    _visibleInContainer: function(element, scroll) {
        var scrollBox = scroll.getBoundingClientRect();
        var elTop = element.getBoundingClientRect().top;
        return elTop >= scrollBox.top && elTop < scrollBox.bottom;
    },

    /**
     * Adjust a containers scroll position to place an element at the top only if that element is not already visible.
     */
    scrollToElement: function(element, container) {
        if (!this._visibleInContainer(element, container)) {
            container.scrollTop = element.offsetTop;
        }
    },

    /**
     * Scroll an element into view only if it doesn't seem like it is visible.
     *
     * This utilizes the browsers scrollIntoView().  This will effect much more than just the minimal scroll bars
     */
    scrollIntoViewIfNeeded: function(element, limit) {
        if (!this._visibleInParentScroll(element, limit)) {
            element.scrollIntoView();
        }
    }

};
